module.exports = __webpack_public_path__ + "img/QR.d1aab43c.png";